import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import AdminLogsHistorySearch from "../../../components/Admin/AdminLogsHistoryComponent/AdminLogsHistorySearch";
import AdminLogsHistoryTable from "../../../components/Admin/AdminLogsHistoryComponent/AdminLogsHistoryTable";
import DatePickerComponent from "../../../components/Common/DatePicker/DatePicker";
import "../../../components/Admin/AdminLogsHistoryComponent/index.css";
import "./index.css";

const LogsHistory = () => {
  const { logsHistory } = useSelector((state) => state.logsHistoryReducer);
  const [logHistoryData, setLogHistoryData] = useState([]);
  const [searchedLogsHistory, setSearchedLogsHistory] = useState([]);
  const saveSearchedArray = (data) => {
    setSearchedLogsHistory(data);
  };

  useEffect(() => {
    setLogHistoryData(
      logsHistory.filter(
        (log) =>
          log.message !== "Получаване на всички организации" &&
          log.message !==
            "Получаване на конфигурация - deliveryEnabled- за меню"
      )
    );
  }, [logsHistory]);

  return (
    <>
      <PageHeader text="История на събитията" />
      <div className="logs-history-date-picker-container">
        <DatePickerComponent />
      </div>
      <AdminLogsHistorySearch
        sendSearchedArray={saveSearchedArray}
        logHistoryData={logHistoryData}
      />
      <AdminLogsHistoryTable
        searchedLogsHistory={searchedLogsHistory}
        logHistoryData={logHistoryData}
      />
    </>
  );
};

export default LogsHistory;
